import { hubbleAPI } from './url'
const resource = hubbleAPI + 'secure/public/anumber'
export default ($axios) => {
  return {
    getNumberBatch(pattern = '') {
      pattern = '*' + pattern + '*';
      return $axios.get(`${resource}/numberbatch/${pattern}`)
    },
    reservationOfNumber(numberID) {
      return $axios.get(`${resource}/reservation/${numberID}`)
    },
    cancelReservation(numberID) {
      return $axios.get(`${resource}/cancelreservation/${numberID}`)
    }
  };
}
